import { render, staticRenderFns } from "./ModalTrocarEmpresa.vue?vue&type=template&id=12c1bc70&scoped=true"
import script from "./ModalTrocarEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalTrocarEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ModalTrocarEmpresa.vue?vue&type=style&index=0&id=12c1bc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1bc70",
  null
  
)

export default component.exports